import { css, type CSSObject } from '@emotion/react'
import { Color, wideGamutColor, ZIndex } from '@opallabs/gem'
import { type WithRequiredTheme } from '@opallabs/lapidary'

export const fullScreenClose = css({
  inlineSize: '32px',
  blockSize: '32px',
  position: 'fixed',
  insetBlockStart: '64px',
  insetInlineEnd: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'none',
  border: 0,
  padding: 0,
  cursor: 'pointer',
  borderRadius: '6px',
  zIndex: ZIndex.Drawer.Content,
})

export const fullScreenCloseDynamic = ({
  theme,
}: WithRequiredTheme): CSSObject => ({
  color: Color[theme].Text.Default,

  '&:hover': {
    backgroundColor: wideGamutColor(Color[theme].Surface.A450, 0.2),
  },
})
